export default "__VITE_ASSET__4129394e__"